import { HiOutlineLockClosed } from "react-icons/hi2";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const SubscribeModal = ({
  open,
  onClose,
  courseName,
  title,
  description,
}) => {
  const navigate = useNavigate();
  const { theme } = useSelector((state) => state.theme);

  if (!open) return null;

  const isDark = theme === "dark";
  const heading = title || "Please subscribe to open this course";
  const body = description || (
    courseName ? (
      <>
        <span className={`font-semibold ${isDark ? "text-gray-200" : "text-gray-800"}`}>
          {courseName}
        </span>{" "}
        is available to subscribers. Subscribe to unlock the video, documents, and full
        course content.
      </>
    ) : (
      "This course is available to subscribers. Subscribe to unlock the video, documents, and full course content."
    )
  );

  const goToPayment = () => {
    navigate("/payment");
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="subscribe-modal-title"
        onClick={(e) => e.stopPropagation()}
        className={`relative w-full max-w-md rounded-2xl p-6 shadow-2xl ${
          isDark ? "bg-[#2f3349] text-[#cfd3ec]" : "bg-white text-gray-800"
        }`}
      >
        <button
          type="button"
          onClick={onClose}
          className={`absolute top-3 right-4 text-2xl leading-none ${
            isDark ? "text-gray-400 hover:text-white" : "text-gray-400 hover:text-gray-700"
          }`}
          aria-label="Close"
        >
          &times;
        </button>

        <div
          className={`mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full ${
            isDark ? "bg-indigo-500/20 text-indigo-300" : "bg-indigo-50 text-indigo-600"
          }`}
        >
          <HiOutlineLockClosed size={28} />
        </div>

        <h2
          id="subscribe-modal-title"
          className={`text-center text-xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}
        >
          {heading}
        </h2>
        <p
          className={`mt-3 text-center text-sm leading-relaxed ${
            isDark ? "text-gray-400" : "text-gray-600"
          }`}
        >
          {body}
        </p>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row">
          <button
            type="button"
            onClick={onClose}
            className={`flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold transition ${
              isDark
                ? "bg-gray-700 text-gray-200 hover:bg-gray-600"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            Not now
          </button>
          <button
            type="button"
            onClick={goToPayment}
            className="flex-1 rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700"
          >
            Subscribe now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscribeModal;
